module.exports = __webpack_public_path__ + "static/media/dodgem(1).b6f0d879.PNG";